import React, { useEffect, useRef, useState } from "react";
import "./LeaderBoard.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import {
    fetchOverallTeamPoints, getDailyBattleRuns,
    getFavTeamRuns,
    getOverAllPoints,
    IplTeamList,
    SquadDetails,
    SquadListApi,
    topOverAllLeagueLeaderboard,
    topClgLeagueLeaderboard,
} from "../../../apis/iplBattle";
import { FaCopy } from "react-icons/fa";
import OverallLeaderboard from "./overall-leaderboard/OverallLeaderboard";

const BattleLeaderBoard = () => {
    const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
        useUserInfo();

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(userDetails?.selectedLeaderboardType || "PRIVATE LEAGUE");
    const [IplTeam, setIplTeam] = useState([]);
    const [SquadTeam,setSquadTeam]=useState([]);
    const [selectedSquad,setSelectedSquad]=useState(null);
    const [selectedSquadCode ,setSelectedSquadCode]=useState(null);
    const [squadDetail,setSquadDetail]=useState([]);
    const [selectedTeam, setSelectedTeam] = useState(IplTeam?.[0]?._id);
    const IsTBD = process.env.REACT_APP_IS_TBD_ID;
    const DropdownMenu = [
        "PRIVATE LEAGUE",
        "OVERALL RUNS",
        "DAILY RUNS",
        "TEAMS POINTS TABLE",
        "MOST FAVOURITE RUNS",
        "SQUAD LEADER BOARD",
        "COLLEGE LEADER BOARD"
    ];
    const options = watchScreen?.current_battle?._id ? DropdownMenu : DropdownMenu?.filter((el) => el !== "DAILY RUNS");

    const [loading, setLoading] = useState(false);
    const [squadLeaderboard, setSquadLeaderboard] = useState([]);
    const [yourSquadLeaderboardRank, setYourSquadLeaderboardRank] = useState(null);

    const [teamPoints, setTeamPoints] = useState([]);

    const [overAllRuns, setOverAllRuns] = useState([]);
    const [OverAllRunsIndividual, setOverAllRunsIndividual] = useState([]);

    const [dailyRuns, setDailyRuns] = useState([]);
    const [yourDailyRuns, setYourDailyRuns] = useState([]);

    const [FavTeam, setFavTeam] = useState([]);
    const [yourFavTeam, setYourFavTeam] = useState([]);

    const [collegeLeaderboard, setCollegeLeaderboard] = useState([]);
    const [yourCollegeLeaderboardRank, setYourCollegeLeaderboardRank] = useState(null);

    const getTeamPoints = async () => {
        setLoading(true);
        try {
            const data = await fetchOverallTeamPoints(watchScreen?.cricketLeague);
            if (data) {
                setTeamPoints(data?.teams?.filter((el)=>el?.teamId!=IsTBD));
            }
        } finally {
            setLoading(false);
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const OverAllBattleRuns = async () => {
        setLoading(true);
        try {
            const response = await getDailyBattleRuns(
                watchScreen?.current_battle?._id,
                watchScreen?.cricketLeague
            );
            setDailyRuns(response?.topUsers);
            setYourDailyRuns(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };
   const PrivateLeagueList = async (selectedSquadId) => {
        setLoading(true);
        try {
            console.log(selectedSquadId,'selectedSquadId');
            
            const response = await SquadDetails(selectedSquadId);
            console.log("Squad Details Response:", response);
            
            if (response && Array.isArray(response)) {
                // Sort by rank to ensure consistent display
                const sortedResponse = [...response?.usersData].sort((a, b) => a.rank - b.rank);
                setSquadDetail(sortedResponse);
            } else {
                setSquadDetail(response?.usersData);
            }
        } finally {
            setLoading(false);
        }
    };
    const getFavTeam = async (selectedTeamId) => {
        setLoading(true);
        try {
            const response = await getFavTeamRuns(
                selectedTeamId || selectedTeam,watchScreen?.cricketLeague
            );
            setFavTeam(response?.topUsers);
            setYourFavTeam(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };

    const OverAllRuns = async () => {
        setLoading(true);
        try {
            const response = await getOverAllPoints(
                watchScreen?.cricketLeague
            );
            setOverAllRuns(response?.topUsers);
            setOverAllRunsIndividual(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };

    const fetchSquadLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await topOverAllLeagueLeaderboard();
            console.log("Squad Leaderboard response:", response);
            if (response) {
                setSquadLeaderboard(response?.topOverAllLeague || []);
                setYourSquadLeaderboardRank(response?.yourOverAllLeague?.[0] || null);
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchCollegeLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await topClgLeagueLeaderboard();
            console.log("College Leaderboard response:", response);
            if (response) {
                setCollegeLeaderboard(response?.topClgLeague || []);
                setYourCollegeLeaderboardRank(response?.yourClgLeague?.[0] || null);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
        if (option === "DAILY RUNS") {
            OverAllBattleRuns();
        } else if (option === "TEAMS POINTS TABLE") {
            getTeamPoints();
        } else if (option === "MOST FAVOURITE RUNS") {
            getFavTeam();
        } else if (option === "OVERALL RUNS") {
            OverAllRuns();
        } else if (option === "PRIVATE LEAGUE") {
            if (selectedSquad) {
                PrivateLeagueList(selectedSquad);
            } else if (SquadTeam && SquadTeam?.length > 0) {
                setSelectedSquad(SquadTeam[0]?.squadId);
                setSelectedSquadCode(SquadTeam[0]?.squadCode);
                PrivateLeagueList(SquadTeam[0]?.squadId);
            }
        } else if (option === "SQUAD LEADER BOARD") {
            fetchSquadLeaderboard();
        } else if (option === "COLLEGE LEADER BOARD") {
            fetchCollegeLeaderboard();
        }
    };

    const handleTeamSelect = async (team) => {
        setSelectedTeam(team);
        await getFavTeam(team);
    };
    const handleSquadSelect = async (squadId,squadCode) => {
        setSelectedSquad(squadId);
        setSelectedSquadCode(squadCode);
        await PrivateLeagueList(squadId);
    };
    useEffect(() => {
        const OverAllRuns = async () => {
            setLoading(true);
            const response = await getOverAllPoints(
                watchScreen?.cricketLeague
            );
            if (response) {
                setLoading(false);
                setOverAllRuns(response?.topUsers);
                setOverAllRunsIndividual(response?.yourDetails);
            }
        };
        OverAllRuns();
    }, []);
    useEffect(() => {
        const fetchTeamAndSquad = async () => {
            updateUserInfo((prev) => ({
                ...prev,
                isLoading: true,
            }));
            const result = await IplTeamList(watchScreen?.cricketLeague);
            const Squad = await SquadListApi(userDetails?.userDetails?.telegramId);
            console.log("Squad List Response:", Squad);
            
            if (Squad && Squad?.userSquads && Squad?.userSquads?.length > 0) {
                setSquadTeam(Squad?.userSquads);
                setSelectedSquad(Squad?.userSquads[0]?.squadId);
                setSelectedSquadCode(Squad?.userSquads[0]?.squadCode);
                PrivateLeagueList(Squad?.userSquads[0]?.squadId);
            }
            
            if (result) {
                setIplTeam(result.teams?.filter((el)=>el?._id!=IsTBD));
                setSelectedTeam(result?.teams?.[0]?._id);
                getFavTeam(result?.teams?.[0]?._id);
                // Fetch team points data when component mounts
                await getTeamPoints();
            } else {
                console.log("error in api match");
            }

            updateUserInfo((prev) => ({
                ...prev,
                isLoading: false,
            }));
        };

        fetchTeamAndSquad();
    }, []);

    useEffect(() => {
        if (selectedOption === "TEAMS POINTS TABLE") {
            getTeamPoints();
        } else if (selectedOption === "OVERALL RUNS") {
            OverAllRuns();
        } else if (selectedOption === "MOST FAVOURITE RUNS"&& selectedTeam) {
            getFavTeam();
        } else if (selectedOption === "DAILY RUNS") {
            OverAllBattleRuns();
        } else if (selectedOption === "PRIVATE LEAGUE") {
            if (selectedSquad) {
                PrivateLeagueList(selectedSquad);
            }
        } else if (selectedOption === "SQUAD LEADER BOARD") {
            fetchSquadLeaderboard();
        } else if (selectedOption === "COLLEGE LEADER BOARD") {
            fetchCollegeLeaderboard();
        }
    }, [selectedOption]);

    const scrollableRef = useRef(null);
    const headerScrollRef = useRef(null);
    const bodyScrollRef = useRef(null);

    useEffect(() => {
        if (scrollableRef.current) {
            setTimeout(() => {
                if (scrollableRef.current) {
                    scrollableRef.current.scrollLeft = 5;
                    setTimeout(() => {
                        if (scrollableRef.current) {
                            scrollableRef.current.scrollLeft = 0;
                        }
                    }, 300);
                }
            }, 500);
        }
    }, []);

    useEffect(() => {
        const headerElement = headerScrollRef.current;
        const bodyElement = bodyScrollRef.current;

        if (!headerElement || !bodyElement) return;

        // Function to sync scroll positions
        const syncScroll = (primary, secondary) => {
            secondary.scrollLeft = primary.scrollLeft;
        };

        // Event listeners for scroll synchronization
        const handleHeaderScroll = () => syncScroll(headerElement, bodyElement);
        const handleBodyScroll = () => syncScroll(bodyElement, headerElement);

        // Add event listeners
        headerElement.addEventListener("scroll", handleHeaderScroll);
        bodyElement.addEventListener("scroll", handleBodyScroll);

        // Initial scroll to indicate scrollability
        setTimeout(() => {
            if (bodyElement) {
                bodyElement.scrollLeft = 5;
                setTimeout(() => {
                    if (bodyElement) {
                        bodyElement.scrollLeft = 0;
                    }
                }, 300);
            }
        }, 500);

        // Clean up event listeners
        return () => {
            if (headerElement)
                headerElement.removeEventListener("scroll", handleHeaderScroll);
            if (bodyElement)
                bodyElement.removeEventListener("scroll", handleBodyScroll);
        };
    }, []);

    const teamColors = {
        // IPL Teams
        CHENNAI: "#8A7E00",
        RAJASTHAN: "#720A40",
        KOLKATA: " #1E083E",
        BENGALURU: "#6D0000",
        GUJARAT: "#181E31",
        MUMBAI: "#0D305D",
        HYDERABAD: "#AE6E02",
        PUNJAB: "#7F0F17",
        DELHI: "#134381",
        LUCKNOW: "#0A204D",
        
        // TNPL Teams
        CHEPAUK: "#8A7E00",  // Deep indigo
        NELLAI: "#8A7E00",   // Dark red
        MADURAI: "#0D305D",  // Dark green
        DINDIGUL: "#8A7E00", // Deep purple
        TIRUPPUR: "#720A40", // Dark blue
        SALEM: "#6D0000",    // Crimson red
        COIMBATORE: "#0D305D",    // Dark teal
        TRICHY: "#009B81",  // Dark brown
        
        // MPL Teams
        RATHNAGIRI: "#181E31",   // Royal purple
        NASHIK: "#8A7E00", // Navy blue
        SATARA: "#0D305D", // Saddle brown
        RAIGAD: "#720A40",    // Dark cyan
        PUNERI: "#0D305D", // Dark brown
        KOLHAPUR: "#6D0000"   // Forest green
    };
    const [isCopied, setIsCopied] = useState(false);
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setIsCopied(true);
        // Reset the copied state after 2 seconds
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      };
      const goToThePage = (component, name, leaderboardType) => {
        updateUserInfo((prev) => ({
          ...prev,
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
          selectedLeaderboardType: leaderboardType // Add this to track which leaderboard to show
        }));
      }; 
    return (
        <>
         <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg" class="cancel-imgleaderboard" onClick={()=>goToThePage(OverallLeaderboard,'OverAllTeamLeaderBoard')} style={{pointerEvents:"fill",zIndex:'999'}}></img>
            <div
                className="menupointer"
                style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    pointerEvents: "all",
                }}
            >
                {/* DAILY RUNS */}
                {loading ? (
                    <div className="loaderstyle">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div
                        className="carousel_container daily-Runs"
                        style={{
                            display: selectedOption === "DAILY RUNS" ? "block" : "none",
                        }}
                    >
                        <div className="the_bg_color-dailyRun"></div>
                        <div>
                            <div className="col-12">
                                <h3 className="leaderboard-text" style={{ marginTop: "0px" }}>
                                    LEADERBOARD
                                </h3>
                                <div className="dropdown-container">
                                    <div className="dropdown-header">
                                        <div className="unique-dropdown">
                                            <div
                                                className="unique-dropdown-header"
                                                onClick={toggleDropdown}
                                            >
                                                <span
                                                    className="firstFont"
                                                    style={{ fontSize: "11px" }}
                                                >
                                                    {selectedOption}
                                                </span>
                                                <button
                                                    className="unique-dropdown-button"
                                                    onClick={toggleDropdown}
                                                    aria-label="Toggle dropdown"
                                                >
                                                    <svg
                                                        className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                            }`}
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="#4CF038"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M12 16L6 8H18L12 16Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                            {isOpen && (
                                                <ul
                                                    className="unique-dropdown-menu firstFont"
                                                    style={{ zIndex: "20" }}
                                                >
                                                    {options?.map((option, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() => handleSelect(option)}
                                                            className="firstFont"
                                                        >
                                                            {option}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="cheap-stuff-container leaderborad-battle daily_-runs">
                                    {dailyRuns?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "10%",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item?.favTeamLogo ||
                                                        "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                                    }
                                                    className="player-icon"
                                                    alt="Player Icon"
                                                    style={{
                                                        width: "12%",
                                                        maxWidth: "40px",
                                                        height: "auto",
                                                        marginRight: "2%",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                                <h4 className="firstFont leaderboard_text">
                                                    {item?.name ? item?.name?.toUpperCase() : "UNKNOWN"}
                                                </h4>
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item?.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "34px", gap: "26px" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <p
                                                        style={{
                                                            paddingLeft: "18px",
                                                            color: "#7B7B7B",
                                                            fontSize: "14px",
                                                            paddingRight: "0px",
                                                            paddingBottom: "3px",
                                                        }}
                                                    >
                                                        TOTAL RUNS
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "#ffffff",
                                                            paddingBottom: "5px",
                                                            fontSize: "13px",
                                                            paddingLeft: "5px",
                                                        }}
                                                    >
                                                        {Math?.round(item?.userRuns)}
                                                    </p>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        paddingRight: "4px",
                                                        gap: "10px",
                                                    }}
                                                >
                                                    <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                        SELECTED TEAM
                                                    </p>
                                                    <img
                                                        height={16}
                                                        width={16}
                                                        src={
                                                            item?.selectedTeamLogo ||
                                                            "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                                        }
                                                        alt="Selected Team"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div
                                    className="row mt0 cheap-rank battle_-rank"
                                    style={{ width: "100%" }}
                                >
                                    <div
                                        className="col-9 stuff-text1 leader-color"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginTop: "4%",
                                            paddingLeft: "16px",
                                        }}
                                    >
                                        <img
                                            src={
                                                yourDailyRuns?.favTeamLogo ||
                                                "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                            }
                                            className="player-icon"
                                            alt="Player Icon"
                                            style={{
                                                width: "12%",
                                                maxWidth: "40px",
                                                height: "auto",
                                                marginRight: "2%",
                                                borderRadius: "50%",
                                            }}
                                        />
                                        <h4>{"You"}</h4>
                                        <p
                                            className="stuff-p"
                                            style={{ paddingLeft: "8px", fontSize: "12px" }}
                                        >
                                            ({yourDailyRuns?.playedMatches || 0}/70)
                                        </p>
                                    </div>
                                    <div
                                        className="col-3 rankbg battle_rank"
                                        style={{
                                            marginTop: "17px",
                                            width: "16%",
                                            marginLeft: "-1%",
                                            marginTop: "4%",
                                        }}
                                    >
                                        <h3 style={{ transform: "translate(1px,3px)" }}>
                                            {yourDailyRuns?.rank || 22}
                                        </h3>
                                    </div>
                                    <div
                                        className="total_taps-battle"
                                        style={{ gap: "25px", marginBottom: "4px" }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                paddingLeft: "30px",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    paddingBottom: "0%",
                                                    color: "#7B7B7B",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                TOTAL RUNS
                                            </p>
                                            <p style={{ color: "#ffffff", paddingLeft: "4px" }}>
                                                {Math.round(yourDailyRuns?.userRuns || 0)}
                                            </p>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                paddingRight: "2px",
                                                gap: "10px",
                                            }}
                                        >
                                            <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                SELECTED TEAM
                                            </p>
                                            <img
                                                height={16}
                                                width={16}
                                                src={
                                                    yourDailyRuns?.selectedTeamLogo
                                                }
                                                alt="Selected Team"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* OVERALL RUNS */}
                {loading ? (
                    <div className="loaderstyle">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div
                        className="carousel_container overAll-Runs"
                        style={{
                            display: selectedOption === "OVERALL RUNS" ? "block" : "none",
                        }}
                    >
                        <div className="the_bg_color-overAllrun"></div>
                        <div>
                            <div className="col-12">
                                <h3 className="leaderboard-text" style={{ marginTop: "0px" }}>
                                    LEADERBOARD
                                </h3>
                                <div className="dropdown-container">
                                    <div className="dropdown-header">
                                        <div className="unique-dropdown">
                                            <div
                                                className="unique-dropdown-header"
                                                onClick={toggleDropdown}
                                            >
                                                <span
                                                    className="firstFont"
                                                    style={{ fontSize: "11px" }}
                                                >
                                                    {selectedOption}
                                                </span>
                                                <button
                                                    className="unique-dropdown-button"
                                                    onClick={toggleDropdown}
                                                    aria-label="Toggle dropdown"
                                                >
                                                    <svg
                                                        className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                            }`}
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="#4CF038"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M12 16L6 8H18L12 16Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                            {isOpen && (
                                                <ul
                                                    className="unique-dropdown-menu firstFont"
                                                    style={{ zIndex: "20" }}
                                                >
                                                    {options?.map((option, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() => handleSelect(option)}
                                                            className="firstFont"
                                                        >
                                                            {option}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="cheap-stuff-container leaderborad-battle overAllRuns">
                                    {overAllRuns?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "40px",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.favTeamLogo ||
                                                        "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                                    }
                                                    className="player-icon"
                                                    alt="Player Icon"
                                                    style={{
                                                        width: "12%",
                                                        maxWidth: "40px",
                                                        height: "auto",
                                                        marginRight: "2%",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                                <h4 className="firstFont leaderboard_text">
                                                    {item?.name?.toUpperCase()}
                                                </h4>
                                                <p
                                                    style={{
                                                        textAlign: "center",
                                                        marginTop: "20px",
                                                        paddingLeft: "7px",
                                                        fontSize: "12px",
                                                        color: "#4CF03894",
                                                    }}
                                                >
                                                    {`(${item?.playedMatches}/70)`}
                                                </p>
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item?.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "32px", gap: "20px" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <p
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: "#7B7B7B",
                                                            fontSize: "14px",
                                                            paddingRight: "0px",
                                                            paddingBottom: "3px",
                                                        }}
                                                    >
                                                        TOTAL RUNS
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "#ffffff",
                                                            paddingBottom: "5px",
                                                            fontSize: "13px",
                                                            paddingLeft: "28px",
                                                        }}
                                                    >
                                                        {Math?.round(item?.userRuns)}
                                                    </p>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        paddingRight: "0px",
                                                        gap: "3px",
                                                    }}
                                                >
                                                    <img
                                                        height={16}
                                                        width={16}
                                                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/like.svg"
                                                    />
                                                    <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                        {Math?.round(item?.yourFavTeamRuns)} |
                                                    </p>
                                                    <img
                                                        height={16}
                                                        width={16}
                                                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/unlike.svg"
                                                    />
                                                    <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                        {Math?.round(item?.yourHatedTeamRuns)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div
                                    className="row mt0 cheap-rank battle_-rank"
                                    style={{ width: "100%" }}
                                >
                                    <div
                                        className="col-9 stuff-text1 leader-color"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginTop: "4%",
                                            paddingLeft: "10%",
                                        }}
                                    >
                                        <img
                                            src={
                                                OverAllRunsIndividual?.favTeamLogo ||
                                                "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                            }
                                            className="player-icon"
                                            alt="Player Icon"
                                            style={{
                                                width: "12%",
                                                maxWidth: "40px",
                                                height: "auto",
                                                marginRight: "2%",
                                                borderRadius: "50%",
                                            }}
                                        />
                                        <h4>{"YOU"}</h4>
                                        <p
                                            className="stuff-p"
                                            style={{ paddingLeft: "8px", fontSize: "12px" }}
                                        >
                                            ({OverAllRunsIndividual?.playedMatches || 0}/70)
                                        </p>
                                    </div>
                                    <div
                                        className="col-3 rankbg battle_rank"
                                        style={{
                                            marginTop: "17px",
                                            width: "16%",
                                            marginLeft: "1px",
                                            marginTop: "4%",
                                        }}
                                    >
                                        <h3 style={{ transform: "translate(1px,3px)" }}>
                                            {OverAllRunsIndividual?.rank || 22}
                                        </h3>
                                    </div>
                                    <div
                                        className="total_taps-battle"
                                        style={{ gap: "28px", marginBottom: "4px" }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                paddingLeft: "32px",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    paddingBottom: "0%",
                                                    color: "#7B7B7B",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                TOTAL RUNS
                                            </p>
                                            <p style={{ color: "#ffffff", paddingLeft: "4px" }}>
                                                {Math.round(OverAllRunsIndividual?.userRuns || 0)}
                                            </p>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                paddingRight: "4px",
                                                gap: "5px",
                                            }}
                                        >
                                            <img
                                                height={16}
                                                width={16}
                                                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/like.svg"
                                            />
                                            <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                {Math.round(
                                                    OverAllRunsIndividual?.yourFavTeamRuns || 0
                                                )}{" "}
                                                |
                                            </p>
                                            <img
                                                height={16}
                                                width={16}
                                                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/unlike.svg"
                                            />
                                            <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                {Math.round(
                                                    OverAllRunsIndividual?.yourHatedTeamRuns || 0
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* FAVOURITE RUNS */}
                <div
                    className="carousel_container most_fav_runs"
                    style={{
                        display:
                            selectedOption === "MOST FAVOURITE RUNS" ? "block" : "none",
                    }}
                >
                    <div className="the_bg_color-favRun"></div>
                    <div>
                        <div className="col-12">
                            <h3 className="leaderboard-text" style={{ marginTop: "1px" }}>
                                LEADERBOARD
                            </h3>
                            <div className="dropdown-container">
                                <div className="dropdown-header">
                                    <div className="unique-dropdown">
                                        <div
                                            className="unique-dropdown-header"
                                            onClick={toggleDropdown}
                                        >
                                            <span className="firstFont" style={{ fontSize: "11px" }}>
                                                {selectedOption}
                                            </span>
                                            <button
                                                className="unique-dropdown-button"
                                                onClick={toggleDropdown}
                                                aria-label="Toggle dropdown"
                                            >
                                                <svg
                                                    className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                        }`}
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="#4CF038"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M12 16L6 8H18L12 16Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        {isOpen && (
                                            <ul
                                                className="unique-dropdown-menu firstFont"
                                                style={{ zIndex: "20" }}
                                            >
                                                {options?.map((option, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSelect(option)}
                                                        className="firstFont"
                                                    >
                                                        {option}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    {/* <div
 className="timer firstFont"
 style={{ zIndex: "2", color: "#474747" }}
 >
 ENDS IN <CountdownTimer enddate={watchScreen?.current_battle?.endDate}/>
 </div> */}
                                </div>
                            </div>

                            <div className="team-selection-container">
                                {IplTeam?.map((team, index) => (
                                    <button
                                        id="teams_btn"
                                        key={index}
                                        className={`team-card ${selectedTeam === team._id ? "selected" : ""
                                            }`}
                                        onClick={() => handleTeamSelect(team?._id)}
                                    >
                                        {team?.teamName}
                                    </button>
                                ))}
                            </div>

                            <div className="cheap-stuff-container leaderborad-battle board_daily">
                                {FavTeam && FavTeam?.length > 0 ? (
                                    FavTeam?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "10%",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.favTeamLogo ||
                                                        "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                                    }
                                                    className="player-icon"
                                                    alt="Player Icon"
                                                    style={{
                                                        width: "12%",
                                                        maxWidth: "40px",
                                                        height: "auto",
                                                        marginRight: "2%",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                                <h4
                                                    className="firstFont leaderboard_text"
                                                    style={{ fontSize: "15px" }}
                                                >
                                                    {item.name ? item.name.toUpperCase() : "UNKNOWN"}
                                                </h4>
                                                <p
                                                    style={{
                                                        textAlign: "center",
                                                        marginTop: "20px",
                                                        paddingLeft: "7px",
                                                        fontSize: "12px",
                                                        color: "#4CF03894",
                                                    }}
                                                >
                                                    {`(${item.playedMatches || 0}/70)`}
                                                </p>
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "20px", gap: "25px" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <p
                                                        style={{
                                                            paddingLeft: "26px",
                                                            color: "#7B7B7B",
                                                            fontSize: "14px",
                                                            paddingRight: "1px",
                                                            paddingBottom: "3px",
                                                        }}
                                                    >
                                                        TOTAL RUNS {"  "}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "#ffffff",
                                                            paddingBottom: "5px",
                                                            fontSize: "13px",
                                                            paddingLeft: "5px",
                                                        }}
                                                    >
                                                        {Math.round(item.userRuns)}
                                                    </p>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        paddingRight: "1px",
                                                        gap: "5px",
                                                    }}
                                                >
                                                    <img
                                                        height={16}
                                                        width={16}
                                                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/like.svg"
                                                    />
                                                    <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                        {Math.round(item.yourFavTeamRuns || 0)} |
                                                    </p>

                                                    <img
                                                        height={16}
                                                        width={16}
                                                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/unlike.svg"
                                                    />
                                                    <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                                        {Math.round(item.yourHatedTeamRuns || 0)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: "#FCFCFC",
                                            fontSize: "16px",
                                            margin: "100px ",
                                        }}
                                    >
                                        NO RECORDS FOUND!
                                    </div>
                                )}
                            </div>
                           {yourFavTeam?.telegramId&& 
                            <div
                                className="row mt0 cheap-rank battle_-rank"
                                style={{ width: "100%" }}
                            >
                                <div
                                    className="col-9 stuff-text1 leader-color"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "4%",
                                        paddingLeft: "20px",
                                    }}
                                >
                                    <img
                                        src={
                                            yourFavTeam?.favTeamLogo ||
                                            "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                        }
                                        className="player-icon"
                                        alt="Player Icon"
                                        style={{
                                            width: "12%",
                                            maxWidth: "40px",
                                            height: "auto",
                                            marginRight: "6px",
                                            borderRadius: "50%",
                                        }}
                                    />
                                    <h4>{"You"}</h4>

                                    <p
                                        className="stuff-p"
                                        style={{ paddingLeft: "8px", fontSize: "12px" }}
                                    >
                                        ({yourFavTeam?.playedMatches || 0}/70)
                                    </p>
                                </div>
                                <div
                                    className="col-3 rankbg battle_rank "
                                    style={{
                                        marginTop: "17px",
                                        width: "16%",
                                        marginLeft: "2px",
                                        marginTop: "4%",
                                    }}
                                >
                                    <h3 style={{ transform: "translate(1px,3px)" }}>
                                        {yourFavTeam?.rank || 0}
                                    </h3>
                                </div>
                                <div
                                    className="total_taps-battle"
                                    style={{
                                        gap: "27px",
                                        marginBottom: "4px",
                                        paddingLeft: "28px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            paddingLeft: "30px",
                                        }}
                                    >
                                        <p
                                            style={{
                                                paddingBottom: "0%",
                                                color: "#7B7B7B",
                                                fontSize: "14px",
                                            }}
                                        >
                                            TOTAL RUNS
                                        </p>
                                        <p style={{ color: "#ffffff", paddingLeft: "4px" }}>
                                            {Math.round(yourFavTeam?.userRuns || 0)}
                                        </p>
                                    </div>

                                    <div
                                        style={{ display: "flex", paddingRight: "4px", gap: "5px" }}
                                    >
                                        <img
                                            height={16}
                                            width={16}
                                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/like.svg"
                                        />
                                        <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                            {Math.round(yourFavTeam?.yourFavTeamRuns || 0)} |
                                        </p>

                                        <img
                                            height={16}
                                            width={16}
                                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/unlike.svg"
                                        />
                                        <p style={{ color: "#4CF038", fontSize: "12px" }}>
                                            {Math.round(yourFavTeam?.yourHatedTeamRuns || 0)}
                                        </p>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>

                {/* POINTS TABLE */}
                <div
                    className="carousel_container points_table"
                    style={{
                        display: selectedOption === "TEAMS POINTS TABLE" ? "block" : "none",
                    }}
                >
                    <div className="the_bg_color-pointsTable"></div>
                    <div>
                        <h3 className="leaderboard-text" stlye={{ marginTop: "0px" }}>
                            LEADERBOARD
                        </h3>
                        <div className="dropdown-container">
                            <div className="dropdown-header">
                                <div className="unique-dropdown">
                                    <div
                                        className="unique-dropdown-header"
                                        onClick={toggleDropdown}
                                    >
                                        <span className="firstFont" style={{ fontSize: "11px" }}>
                                            {selectedOption}
                                        </span>
                                        <button
                                            className="unique-dropdown-button"
                                            onClick={toggleDropdown}
                                            aria-label="Toggle dropdown"
                                        >
                                            <svg
                                                className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                    }`}
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="#4CF038"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M12 16L6 8H18L12 16Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    {isOpen && (
                                        <ul
                                            className="unique-dropdown-menu firstFont"
                                            style={{ zIndex: "20" }}
                                        >
                                            {options.map((option, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => handleSelect(option)}
                                                    className="firstFont"
                                                >
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                {/* <div
 className="timer firstFont"
 style={{ zIndex: "2", color: "#474747" }}
 >
 ENDS IN <CountdownTimer enddate={watchScreen?.current_battle?.endDate}/>
 </div> */}
                            </div>
                        </div>

                        <div className="grid-table-container points_table">
                            <div className="grid-fixed-column">
                            <div className="grid-cell header-cell sticky-cell">TEAM</div>
                            {teamPoints.map((team) => (
                                <div
                                key={`team-logo-${team.teamId}`}
                                className="grid-cell sticky-cell"
                                style={{
                                    backgroundColor: teamColors[team.teamName] || "#FFFFFF",
                                }}
                                >
                                <div className="team-logo-wrapper">
                                    <img
                                    src={team.teamLogo}
                                    alt={team.teamName}
                                    className="team-logo"
                                    />
                                </div>
                                <div>
                                </div>
                                </div>
                            ))}
                            </div>
                <div
                  className="grid-scrollable-content"
                  ref={scrollableRef}
                  style={{ overflowX: "auto", overflowY: "hidden" }}
                >
                  <div className="grid-scrollable-header">
                    <div className="grid-cell header-cell">NAME</div>
                    <div className="grid-cell header-cell">NO OF MATCHES</div>
                    <div
                      className="grid-cell header-cell"
                      style={{ paddingRight: "5px" }}
                    >
                      WINS
                    </div>
                    <div
                      className="grid-cell header-cell"
                      style={{ paddingRight: "6px" }}
                    >
                      LOSE
                    </div>
                    <div
                      className="grid-cell header-cell"
                      style={{ paddingLeft: "0px", marginLeft: "3px" }}
                    >
                      NO OF RUNS
                    </div>
                    <div
                      className="grid-cell header-cell"
                      style={{
                        marginLeft: "-3px",
                        backgroundColor: "#4CF038",
                        color: "black",
                        borderRadius: "0px 0px 2px 2px",
                      }}
                    >
                      RANK
                    </div>
                  </div>
                  <div className="grid-scrollable-body">
                    {teamPoints.map((team) => (
                      <div
                        className="grid-table-row"
                        key={`team-data-${team.teamId}`}
                      >
                        <div className="grid-cell" style={{
                            backgroundColor: teamColors[team.teamName],
                            fontSize:'10px'
                          }}>
                            {team.teamName}
                          </div>
                        <div
                          className="grid-cell"
                          style={{
                            backgroundColor: teamColors[team.teamName],
                          }}
                        >
                          {team.playedMatches}
                        </div>
                        <div
                          className="grid-cell"
                          style={{
                            backgroundColor: teamColors[team.teamName],
                          }}
                        >
                          {team.winCount}
                        </div>
                        <div
                          className="grid-cell"
                          style={{
                            backgroundColor: teamColors[team.teamName],
                          }}
                        >
                          {team.loseCount}
                        </div>
                        <div
                          className="grid-cell"
                          style={{
                            backgroundColor: teamColors[team.teamName],
                            paddingLeft: "5px",
                            marginLeft: "0px",
                          }}
                        >
                          {team.totalRuns}
                        </div>
                        <div
                          className="grid-cell rank_Font"
                          style={{
                            backgroundColor: teamColors[team.teamName],
                            paddingLeft: "11px",
                          }}
                        >
                          {team.rank}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
                    </div>
                </div>
{/* PRIVATE LEAUGE */}
                <div
                    className="carousel_container most_fav_runs"
                    style={{
                        display:
                            selectedOption === "PRIVATE LEAGUE" ? "block" : "none",
                    }}
                >
                    <div className="the_bg_color-favRun"></div>
                    <div>
                        <div className="col-12">
                            <h3 className="leaderboard-text" style={{ marginTop: "1px" }}>
                                LEADERBOARD
                            </h3>
                            <div className="dropdown-container">
                                <div className="dropdown-header">
                                    <div className="unique-dropdown">
                                        <div
                                            className="unique-dropdown-header"
                                            onClick={toggleDropdown}
                                        >
                                            <span className="firstFont" style={{ fontSize: "11px" }}>
                                                {selectedOption}
                                            </span>
                                            <button
                                                className="unique-dropdown-button"
                                                onClick={toggleDropdown}
                                                aria-label="Toggle dropdown"
                                            >
                                                <svg
                                                    className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                        }`}
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="#4CF038"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M12 16L6 8H18L12 16Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        {isOpen && (
                                            <ul
                                                className="unique-dropdown-menu firstFont"
                                                style={{ zIndex: "20" }}
                                            >
                                                {options.map((option, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSelect(option)}
                                                        className="firstFont"
                                                    >
                                                        {option}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                   
                                </div>
                            </div>

                            <div className="team-selection-container">
                                {SquadTeam?.map((team, index) => (
                                    <button
                                        id="teams_btn"
                                        key={index}
                                        className={`team-card ${selectedSquad === team?.squadId ? "selected" : ""
                                            }`}
                                        onClick={() => handleSquadSelect(team?.squadId,team?.squadCode)}
                                    >
                                        {team?.squadName}
                                    </button>
                                ))}
                            </div>
                            <div className="row displayflex">

                            <div className="col-10 mb-4 ">
                  <div className="d-flex align-items-center justify-content-between code-box">
                    <span className="text-grey text-uppercase">League Code:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span className="text-white code-text">{selectedSquadCode }</span>
                  
                    <FaCopy  onClick={() => copyToClipboard(selectedSquadCode)} /> 
         
                    </div>
                  </div>
                </div>
                            </div>
                           

                            <div className="cheap-stuff-container leaderborad-battle board_daily">
                                {squadDetail && squadDetail.length > 0 ? (
                                    squadDetail?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "10%",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.favTeamLogo ||
                                                        "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk.png"
                                                    }
                                                    className="player-icon"
                                                    alt="Player Icon"
                                                    style={{
                                                        width: "12%",
                                                        maxWidth: "40px",
                                                        height: "auto",
                                                        marginRight: "2%",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                                <h4
                                                    className="firstFont leaderboard_text"
                                                    style={{ fontSize: "15px" }}
                                                >
                                                    {item.userName ? item.userName.toUpperCase() : "UNKNOWN"}
                                                </h4>
                                                
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "20px", gap: "25px" }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <p
                                                        style={{
                                                            paddingLeft: "26px",
                                                            color: "#7B7B7B",
                                                            fontSize: "14px",
                                                            paddingRight: "1px",
                                                            paddingBottom: "3px",
                                                        }}
                                                    >
                                                        TOTAL RUNS {"  "}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "#ffffff",
                                                            paddingBottom: "5px",
                                                            fontSize: "13px",
                                                            paddingLeft: "5px",
                                                        }}
                                                    >
                                                        {Math.round(item.userRuns)}
                                                    </p>
                                                </div>
                                              
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: "#FCFCFC",
                                            fontSize: "16px",
                                            margin: "100px ",
                                        }}
                                    >
                                        NO RECORDS FOUND!
                                    </div>
                                )}
                            </div>
                         
                        </div>
                    </div>
                </div>

                {/* SQUAD LEADER BOARD */}
                <div
                    className="carousel_container most_fav_runs"
                    style={{
                        display:
                            selectedOption === "SQUAD LEADER BOARD" ? "block" : "none",
                    }}
                >
                    <div className="the_bg_color-favRun"></div>
                    <div>
                        <div className="col-12">
                            <h3 className="leaderboard-text" style={{ marginTop: "1px" }}>
                                LEADERBOARD
                            </h3>
                            <div className="dropdown-container">
                                <div className="dropdown-header">
                                    <div className="unique-dropdown">
                                        <div
                                            className="unique-dropdown-header"
                                            onClick={toggleDropdown}
                                        >
                                            <span className="firstFont" style={{ fontSize: "11px" }}>
                                                {selectedOption}
                                            </span>
                                            <button
                                                className="unique-dropdown-button"
                                                onClick={toggleDropdown}
                                                aria-label="Toggle dropdown"
                                            >
                                                <svg
                                                    className={`triangle-icon ${isOpen ? "triangle-rotate" : ""
                                                        }`}
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="#4CF038"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M12 16L6 8H18L12 16Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        {isOpen && (
                                            <ul
                                                className="unique-dropdown-menu firstFont"
                                                style={{ zIndex: "20" }}
                                            >
                                                {options.map((option, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSelect(option)}
                                                        className="firstFont"
                                                    >
                                                        {option}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                   
                                </div>
                            </div>

                            <div className="cheap-stuff-container leaderborad-battle board_daily">
                                {squadLeaderboard && squadLeaderboard.length > 0 ? (
                                    squadLeaderboard?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "10%",
                                                }}
                                            >
                                                <h4
                                                    className="firstFont leaderboard_text"
                                                    style={{ fontSize: "15px" }}
                                                >
                                                    {item?.squadName?.toUpperCase() || "UNKNOWN"}
                                                </h4>
                                                
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item?.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "20px", gap: "90px" }}
                                            >
                                               
                                                    <p
                                                        style={{
                                                            paddingLeft: "26px",
                                                            color: "#7B7B7B",
                                                            fontSize: "14px",
                                                            paddingRight: "1px",
                                                            paddingBottom: "3px",
                                                        }}
                                                    >
                                                        TOTAL RUNS {"  "}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "#ffffff",
                                                            paddingBottom: "5px",
                                                            fontSize: "13px",
                                                            paddingLeft: "5px",
                                                        }}
                                                    >
                                                        {item?.squadRuns}
                                                    </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: "#FCFCFC",
                                            fontSize: "16px",
                                            margin: "100px ",
                                        }}
                                    >
                                        NO RECORDS FOUND!
                                    </div>
                                )}
                            </div>
                         
                        </div>
                    </div>
                </div>

                {/* Add College Leaderboard Section */}
                <div
                    className="carousel_container most_fav_runs"
                    style={{
                        display: selectedOption === "COLLEGE LEADER BOARD" ? "block" : "none",
                    }}
                >
                    <div className="the_bg_color-favRun"></div>
                    <div>
                        <div className="col-12">
                            <h3 className="leaderboard-text" style={{ marginTop: "1px" }}>
                                LEADERBOARD
                            </h3>
                            <div className="dropdown-container">
                                <div className="dropdown-header">
                                    <div className="unique-dropdown">
                                        <div
                                            className="unique-dropdown-header"
                                            onClick={toggleDropdown}
                                        >
                                            <span className="firstFont" style={{ fontSize: "11px" }}>
                                                {selectedOption}
                                            </span>
                                            <button
                                                className="unique-dropdown-button"
                                                onClick={toggleDropdown}
                                                aria-label="Toggle dropdown"
                                            >
                                                <svg
                                                    className={`triangle-icon ${isOpen ? "triangle-rotate" : ""}`}
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="#4CF038"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M12 16L6 8H18L12 16Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        {isOpen && (
                                            <ul
                                                className="unique-dropdown-menu firstFont"
                                                style={{ zIndex: "20" }}
                                            >
                                                {options.map((option, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSelect(option)}
                                                        className="firstFont"
                                                    >
                                                        {option}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="" style={{height:"58vh",overflowY:"scroll"}}>
                                {collegeLeaderboard && collegeLeaderboard.length > 0 ? (
                                    collegeLeaderboard?.map((item, index) => (
                                        <div
                                            className="row cheap_stuff1"
                                            style={{ width: "100%" }}
                                            key={index}
                                        >
                                            <div
                                                className="col-9 stuff-text1 leader-color"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "-4%",
                                                    paddingLeft: "10%",
                                                }}
                                            >
                                                <h4
                                                    className="firstFont leaderboard_text"
                                                    style={{ fontSize: "15px" }}
                                                >
                                                    {item?.squadName?.toUpperCase() || "SQUAD XI"}
                                                </h4>
                                            </div>
                                            <div
                                                className="col-3 rankbg battle_rank"
                                                style={{
                                                    position: "relative",
                                                    marginTop: "10px",
                                                    width: "14%",
                                                }}
                                            >
                                                <h3 style={{ transform: "translate(2px,4px)" }}>
                                                    {item?.rank}
                                                </h3>
                                            </div>
                                            <div
                                                className="total_taps-battle"
                                                style={{ paddingLeft: "20px", gap: "90px" }}
                                            >
                                                <p
                                                    style={{
                                                        paddingLeft: "26px",
                                                        color: "#7B7B7B",
                                                        fontSize: "14px",
                                                        paddingRight: "1px",
                                                        paddingBottom: "3px",
                                                    }}
                                                >
                                                    TOTAL RUNS {"  "}
                                                </p>
                                                <p
                                                    style={{
                                                        color: "#ffffff",
                                                        paddingBottom: "5px",
                                                        fontSize: "13px",
                                                        paddingLeft: "5px",
                                                    }}
                                                >
                                                    {item?.squadRuns}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: "#FCFCFC",
                                            fontSize: "16px",
                                            margin: "100px ",
                                        }}
                                    >
                                        NO RECORDS FOUND!
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BattleLeaderBoard;

